var styles = {
  "RollupActivator": "Polaris-ActionMenu-RollupActions__RollupActivator"
};

export { styles as default };
